import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import { Wrapper } from './wrappers';
import { Button } from './molecules';
import { getIconByName } from './utils';

export const definition = {
  name: "MultipleOptionsButton",
  controller: Controller,
  initialProps: ({ options, selectedOption, allowEdit }) => ({ options, selectedOption, allowEdit }),
  props: internalState,
  elements: [
    {
      component: Button,
      name: 'Option',
      isListOf: 'options',
      bindings: ({ option, allowEdit }) => ({ allowEdit, option, text: option.name, icon: getIconByName({ name: option.name }) }),
      displayState: ({ option, selectedOption, allowEdit }) => ({
        selected: selectedOption === option.name,
        allowEdit
      })
    }
  ]
}

const BadgeCard = ContainerComponent(definition);

export default wrap(BadgeCard, Wrapper);
